module.exports = {"pt-BR":{"components":{"property-state-tag":null}}}